import React, { useEffect, useState } from "react";
import useViewport from "@hooks/useViewport";
import "./style.scss";

const steps = [
    "Finding Session",
    "Checking Available Seats",
    "Redeeming Vouchers",
    "Completing Transaction",
    "Booking Succeeded",
    "Sending your tickets shortly",
];

const stepDescriptions = {
    "Finding Session": "The AI assistant is currently locating a suitable session for your booking.",
    "Checking Available Seats": "Fetching seat map from cinema...",
    "Redeeming Vouchers": "Applying your vouchers...",
    "Completing Transaction": "Entering your payment details...",
    "Booking Succeeded": "Cinema has confirmed your booking.",
    "Sending your tickets shortly": "Generating and sending tickets now...",
};

const V2tSteps = ({ phase, phaseList }) => {
    const [activeStep, setActiveStep] = useState(0);
    const [fillPercent, setFillPercent] = useState(0);
    const [instantFill, setInstantFill] = useState(true);
    const { width } = useViewport();
    const breakpoint = 800;
    const isMobile = width <= breakpoint;
    const totalSegments = steps.length;

    useEffect(() => {
        if (phase === phaseList.CONFIRMED_FINAL || phase === phaseList.ERROR) return;
        if (activeStep >= steps.length - 1) return;

        const timer = setInterval(() => {
            setActiveStep((prev) => prev + 1);
        }, 30000);
        return () => clearInterval(timer);
    }, [activeStep, phase]);

    useEffect(() => {
        const currentStep = Math.min(activeStep, totalSegments);
        const targetStep = Math.min(activeStep + 1, totalSegments);

        setInstantFill(true);
        setFillPercent((currentStep / totalSegments) * 100);

        let raf2;
        const raf1 = requestAnimationFrame(() => {
            raf2 = requestAnimationFrame(() => {
                setInstantFill(false);
                setFillPercent((targetStep / totalSegments) * 100);
            });
        });

        return () => {
            cancelAnimationFrame(raf1);
            cancelAnimationFrame(raf2);
        };
    }, [activeStep, totalSegments]);

    return (
        <div className="success-with-cinema__wrapper">
            <div className="success-with-cinema__steps-wrap">
                <ul className="success-with-cinema__steps">
                    {steps.map((label, index) => (
                        <li
                            key={label}
                            className={`success-with-cinema__step ${
                                index === activeStep ? "active" : ""
                            }`}
                        >
                            <div className="success-with-cinema__circle">{index + 1}</div>

                            {!isMobile && (
                                <div className="success-with-cinema__label">{label}</div>
                            )}
                        </li>
                    ))}
                </ul>

                <div
                    className={`success-with-cinema__steps-fill ${
                        instantFill ? "success-with-cinema__steps-fill--instant" : ""
                    }`}
                    style={{ width: `${fillPercent}%` }}
                />
            </div>

            <div className="success-with-cinema__status">
                <div className="success-with-cinema__title">{steps[activeStep]}</div>

                <div className="success-with-cinema__text">
                    {stepDescriptions[steps[activeStep]]}
                </div>
            </div>
        </div>
    );
};

export default V2tSteps;
